import type { ApplicationCreateInput } from '@masterapps/shared';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { type RegisterSubmitHandlers, ScreenRegister } from '@/components/screens/register-screen';
import { useCreateApplication } from '@/hooks/use-applications';
import { useScreenProps } from '@/store/theme';

export function RegisterPage() {
  const sp = useScreenProps();
  const navigate = useNavigate();
  const create = useCreateApplication();

  // `handlers.onSuccess` é o `clear()` do autosave de rascunho da tela. Precisa
  // rodar ANTES do navigate: a tela desmonta em seguida e um efeito baseado em
  // "isSuccess" não chegaria a executar.
  //
  // `handlers.onError` pinta os campos recusados pelo servidor (400
  // VALIDATION_ERROR) e rola até o primeiro; o toast só repete a mensagem crua
  // da API quando nenhum campo foi identificado.
  const onSubmit = (input: ApplicationCreateInput, handlers: RegisterSubmitHandlers) => {
    create.mutate(input, {
      onSuccess: () => {
        handlers.onSuccess();
        toast.success('Aplicação publicada no catálogo');
        navigate('/admin/inventory');
      },
      onError: (e: Error) => {
        const painted = handlers.onError(e);
        toast.error(painted ? 'Revise os campos destacados no formulário' : e.message);
      },
    });
  };

  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenRegister {...sp} onSubmit={onSubmit} submitting={create.isPending} />
    </div>
  );
}
